// This file is generated by NTypewriter using scriban template (_Models.nt), DO NOT MODIFY THIS FILE
/* tslint:disable */

/**
 *  
 */
export enum ClaimStrings {

    /**
     * The given name
     */
    GivenName = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname',

    /**
     * The username claim (which is <see cref="F:System.Security.Claims.ClaimTypes.Name"/>)
     */
    UserName = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name',

    /**
     * 
     */
    UserID = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier',

    /**
     * 
     */
    UserLevel = 'UserLevel'
}


// WEBPACK FOOTER //
// ./src/model/autogen/ClaimStrings.ts